import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { AnimatePresence } from 'motion/react';
import useOnClickOutside from 'use-onclickoutside';
import FlyoutMenu from './components/FlyoutMenu/FlyoutMenu.js';
import FlyoutMenuItem from './components/FlyoutMenu/FlyoutMenuItem.js';
import FlyoutTrigger from './components/FlyoutTrigger/FlyoutTrigger.js';
import { useOnKeyboardEventOutside } from './utils/use-on-keyboard-outside.js';

const Flyout = (_param)=>{
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    const [isOpen, setIsOpen] = React.useState(false);
    const rootRef = React.useRef(null);
    useOnClickOutside(rootRef, ()=>{
        setIsOpen(false);
    });
    useOnKeyboardEventOutside(rootRef, (event)=>{
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            setIsOpen(false);
        }
    });
    const keyUp = React.useCallback((event)=>{
        if (event.key === 'Escape') {
            setIsOpen(false);
            event.stopPropagation();
        }
    }, [
        setIsOpen
    ]);
    const handleOnClick = React.useCallback(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen,
        setIsOpen
    ]);
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({
        className: classnames('flyout', className),
        ref: rootRef
    }, rest), /*#__PURE__*/ React.createElement(AnimatePresence, null, React.Children.map(children, (child)=>{
        if (!/*#__PURE__*/ React.isValidElement(child)) {
            return;
        }
        if (child.type === FlyoutTrigger) {
            return /*#__PURE__*/ React.createElement(FlyoutTrigger, swcHelpers.extends({
                key: "trigger"
            }, child.props, {
                onClick: handleOnClick,
                isMenuOpen: isOpen,
                onKeyUp: keyUp
            }));
        }
        if (child.type === FlyoutMenu) {
            return isOpen && /*#__PURE__*/ React.createElement(FlyoutMenu, swcHelpers.extends({
                key: "menu"
            }, child.props, {
                onKeyUp: keyUp
            }));
        }
        if (process.env.NODE_ENV !== 'production') {
            console.error('Flyout only accepts Flyout.Trigger and Flyout.Menu as its children');
        }
    })));
};
Flyout.Trigger = FlyoutTrigger;
Flyout.Menu = FlyoutMenu;
Flyout.MenuItem = FlyoutMenuItem;

export { Flyout as default };
//# sourceMappingURL=Flyout.js.map
